/**
 * @usage v-if="$checkRole('dashboard', 'view_chart')"
 * @usage this.$checkRole('dashboard', 'view_chart')
 * @type Boolean
 */

import { store } from "../store";

import dashboardRule from "./rules/dashboard";
import accountsRule from "./rules/accounts";
import buildingsRule from "./rules/buildings";
import commonRule from "./rules/common";
import towingRule from "./rules/towings";

const RULES = {
  common: commonRule,
  dashboard: dashboardRule,
  buildings: buildingsRule,
  accounts: accountsRule,
  towings: towingRule,
};

export default function hasAccess(view = null, rule = null) {
  const userRole = store.getters["authStore/getUserRole"];

  if (!view || !rule) return false;

  const _view = RULES[view];
  const _rule = _view[rule];

  if (!_rule || !_view)
    throw new Error("Invalid rule or view for the Roles permissions!");

  // return only allowed Roles
  return _rule.includes(userRole);
}



// WEBPACK FOOTER //
// ./src/roles/index.js